import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import styled from "styled-components";
import ProductDetails from "../../components/Product/ProductDetails";
import QueryForm from "../../components/Home/QueryForm";
import MediaCenterDetails from "../../components/MediaCenter/MediaCenterDetails";
import InnerBanner from "../../components/InnerBanner";
import {ApiParam as ApiParamKey} from "../../api/network/apiParams";
import {fetchMediaPostDetail} from "../../api/redux/mediacenter";
import {useParams} from "react-router-dom";
import {Helmet, HelmetProvider} from "react-helmet-async";


const MediaDetailsIndex = () => {

    const dispath = useDispatch()

    const getData = useSelector(state => state.mediaReducer)
    let {slug} = useParams();


    // api call
    useEffect(() => {
        let apiUrlSection = apiEndPoints.SECTIONS

        let api_params_sections = {
            [ApiParamKey.type]: 'slug',
            [ApiParamKey.value]: `${slug}`,
            [ApiParamKey.get_section]: 'yes',
            [ApiParamKey.image]: 'yes',
            [ApiParamKey.post]: 'yes',
            [ApiParamKey.file]: 'yes',
        }
        dispath(fetchMediaPostDetail([apiUrlSection, api_params_sections]))
    }, [])

    const page_data = getData?.detail?.data?.page_data;
    const banner = getData?.detail?.data;
    const Details = getData?.detail?.data?.sections;

    return (
        <HelmetProvider>
            <Helmet>
                <title>{`${page_data?.subtitle ? page_data?.subtitle + ' | ' : ''}`}Pacific Blue</title>

                {
                    page_data?.meta_title &&
                    <meta name="meta:title" content={page_data?.meta_title}/>

                }
                {
                    page_data?.meta_description &&
                    <meta name="description" content={page_data?.meta_description}/>

                }
                {
                    page_data?.og_title &&
                    <meta property="og:title" content={page_data?.og_title}/>

                }
                {
                    page_data?.og_description &&
                    <meta property="og:description" content={page_data?.og_description}/>

                }
            </Helmet>
            <StyledSection>
                <InnerBanner text={banner?.page_data?.subtitle} img={banner?.page_images?.list[0]?.full_path}/>
                <MediaCenterDetails data={Details}/>
            </StyledSection>
        </HelmetProvider>
    );
};

const StyledSection = styled.section`
`;

export default MediaDetailsIndex;
